document.addEventListener('DOMContentLoaded', function(){

// ---------- helpers ----------
function moneyFactory(fmt){
  fmt = fmt || ('$' + '{{amount}}');
  function fmtNum(cents, prec){
    var n = (cents/100).toFixed(prec); var p = n.split('.');
    var d = p[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g,'$1,');
    return p[1] ? d + '.' + p[1] : d;
  }
  return function(cents){
    cents = Number(cents) || 0;
    var whole = cents % 100 === 0;
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function(m, tok){
      if(tok.indexOf('no_decimals') > -1) return fmtNum(cents, 0);
      return whole ? fmtNum(cents, 0) : fmtNum(cents, 2);
    });
  };
}
function parseJSON(s, d){ try { return JSON.parse(s); } catch(e){ return d; } }
function freqLabel(name){
  // "Deliver every 4 weeks, 20% off" -> "Every 4 weeks"
  if(!name) return '';
  var n = String(name).split(',')[0].replace(/^deliver\s+/i,'').trim();
  n = n.charAt(0).toUpperCase() + n.slice(1);
  n = n.replace(/every 2 weeks/i,'Every 2 weeks').replace(/every 4 weeks/i,'Every 4 weeks').replace(/every 8 weeks/i,'Every 8 weeks');
  return n;
}
function weeksOf(name){ var m = /(\d+)\s*week/i.exec(String(name||'')); return m ? parseInt(m[1],10) : 99; }
function planMeta(name){
  var n = String(name || '').toLowerCase();
  if(/2\s*week/.test(n)) return {sub:'For serious bread households', tag:''};
  if(/4\s*week/.test(n)) return {sub:'The right pace for most tables', tag:'Most popular'};
  if(/8\s*week/.test(n)) return {sub:'A stocked freezer, twice a season', tag:''};
  return {sub:'Subscribe & save', tag:''};
}
function addToCart(items, cartUrl, onErr){
  return fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify({items: items}) })
    .then(function(r){ if(r.ok) return r.json(); return r.json().then(function(e){ throw new Error(e.description || e.message || ('Add to cart failed ('+r.status+')')); }); })
    .then(function(){ window.location.href = cartUrl || '/cart'; })
    .catch(function(err){ if(onErr) onErr(err); });
}

// ---------- reveal on scroll ----------
var reveals = document.querySelectorAll('.reveal');
if('IntersectionObserver' in window){
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('in'); io.unobserve(en.target); } });
  },{threshold:.12, rootMargin:'0px 0px -40px 0px'});
  reveals.forEach(function(el){ io.observe(el); });
} else { reveals.forEach(function(el){ el.classList.add('in'); }); }
setTimeout(function(){ document.querySelectorAll('.reveal:not(.in)').forEach(function(el){ el.classList.add('in'); }); }, 1400);

// ---------- mobile menu ----------
var burger = document.getElementById('burger'), menu = document.getElementById('menu');
if(burger && menu){ burger.addEventListener('click', function(){ menu.classList.toggle('open'); }); }

// ---------- header shadow + sticky promo bar ----------
var header = document.getElementById('header'), buybar = document.getElementById('buybar');
if(document.getElementById('bbMobileBar')) document.body.classList.add('has-mobilebar');
window.addEventListener('scroll', function(){
  if(header) header.classList.toggle('scrolled', window.scrollY > 10);
  if(buybar){
    var nearBottom = (window.innerHeight + window.scrollY) > (document.body.offsetHeight - 160);
    buybar.classList.toggle('show', window.scrollY > 640 && !nearBottom);
  }
}, {passive:true});

// ---------- pdp gallery thumbs ----------
var main = document.getElementById('pdp-main');
if(main){
  document.querySelectorAll('#pdp-thumbs img').forEach(function(t){
    t.addEventListener('click', function(){
      main.src = t.getAttribute('data-full') || t.src.replace(/width=\d+/,'width=1800');
      document.querySelectorAll('#pdp-thumbs img').forEach(function(x){ x.classList.remove('sel'); });
      t.classList.add('sel');
    });
  });
}

// ---------- promo popup ----------
// Removed. The email-capture modal is driven entirely by the script at the foot of
// layout/theme.liquid. This block used to fight it: it wrote a timestamp into the
// same localStorage key ('bw_promo_v2') that theme.liquid writes the string
// 'subscribed' into, and its parseInt() of that string produced NaN, so its
// "already dismissed?" test always failed and it re-opened the modal after 6s on
// every page load — including for people who had just given their email.

// ---------- generic stepper wiring (loaf cards, add-on cards, PDP qty) ----------
function wireStepper(card, opts){
  opts = opts || {};
  var q = card.querySelector('.bb2-qty'), minus = card.querySelector('.bb2-minus'), plus = card.querySelector('.bb2-plus'), add = card.querySelector('.bb2-add');
  if(!q) return null;
  function get(){ return parseInt(q.getAttribute('data-qty'),10) || 0; }
  function set(n){
    n = Math.max(0, n);
    if(opts.max != null) n = Math.min(n, opts.max);
    q.setAttribute('data-qty', n); q.textContent = n;
    if(minus) minus.disabled = n <= (opts.min || 0);
    card.classList.toggle('picked', n > 0);
    var badge = card.querySelector('[data-badge]');
    if(badge){ badge.hidden = n === 0; var b = badge.querySelector('b'); if(b) b.textContent = n; }
    if(opts.onChange) opts.onChange(n);
  }
  if(plus) plus.addEventListener('click', function(){ if(opts.canAdd && !opts.canAdd()) return; set(get()+1); });
  if(minus) minus.addEventListener('click', function(){ set(get()-1); });
  if(add) add.addEventListener('click', function(){ if(opts.canAdd && !opts.canAdd()) return; set(get()+1); });
  return { get:get, set:set };
}

// ---------- BUILD A BOX v2 ----------
(function(){
  var root = document.getElementById('buildbox'); if(!root) return;
  var money = moneyFactory(root.getAttribute('data-money-format'));
  var cartUrl = root.getAttribute('data-cart-url') || '/cart';
  var sizes = [].slice.call(root.querySelectorAll('.bb2-size'));
  var loaves = [].slice.call(root.querySelectorAll('.bb2-loaf'));
  var addonEls = [].slice.call(root.querySelectorAll('.bb2-addon[data-addon]'));
  var opts = document.getElementById('bbOpts');
  var cta = document.getElementById('bbCta'), ctaM = document.getElementById('bbCtaMobile'), errEl = document.getElementById('bbErr');
  var countEl = document.getElementById('bbCount'), targetEl = document.getElementById('bbTarget'), leftEl = document.getElementById('bbLeft'), hintEl = document.getElementById('bbHint'), bar = document.getElementById('bbBar'), prog = document.getElementById('bbProgress');
  var sumSize = document.getElementById('sumSize'), sumLoaves = document.getElementById('sumLoaves'), sumAddons = document.getElementById('sumAddons'), sumSched = document.getElementById('sumSched'), sumTotal = document.getElementById('sumTotal'), sumCompare = document.getElementById('sumCompare'), sumSave = document.getElementById('sumSave');
  var mbCount = document.getElementById('mbCount'), mbTotal = document.getElementById('mbTotal');

  var active = null, mode = 'sub', planId = null, planName = '';
  var loafCtl = [], addonCtl = [];

  function target(){ return active ? parseInt(active.getAttribute('data-target'),10) : 6; }
  function total(){ var t = 0; loafCtl.forEach(function(c){ t += c.ctl.get(); }); return t; }
  function plansOf(el){ return parseJSON(el.getAttribute('data-plans') || '[]', []); }
  function planFor(el){
    // the plan on el (box or add-on) that matches the selected frequency — by id, else by frequency label
    var list = plansOf(el), hit = null;
    list.forEach(function(p){ if(p.id === planId) hit = p; });
    if(!hit && planName){ var want = freqLabel(planName); list.forEach(function(p){ if(!hit && freqLabel(p.name) === want) hit = p; }); }
    return hit;
  }
  function planPrice(el){
    // price of el (box or add-on) under the current mode/plan
    var once = parseInt(el.getAttribute('data-once'),10) || 0;
    if(mode !== 'sub') return once;
    var hit = planFor(el);
    if(hit) return hit.price;
    var sub = parseInt(el.getAttribute('data-sub'),10);
    return isNaN(sub) ? once : sub;
  }
  function boxOnce(){ return parseInt(active.getAttribute('data-once'),10) || 0; }
  function boxPrice(){ return planPrice(active); }
  function addonsTotal(){ var t = 0, c = 0; addonCtl.forEach(function(a){ var n = a.ctl.get(); if(n){ t += n * planPrice(a.el); c += n * (parseInt(a.el.getAttribute('data-once'),10)||0); } }); return {now:t, once:c}; }

  // ----- schedule options -----
  function renderOpts(){
    var list = plansOf(active).slice().sort(function(a,b){ return weeksOf(a.name) - weeksOf(b.name); }), once = boxOnce();
    opts.innerHTML = '';
    // pick default: 4-week plan if present, else first
    var def = null; list.forEach(function(p){ if(!def && /4\s*week/i.test(p.name)) def = p; }); if(!def && list.length) def = list[0];
    list.forEach(function(p){
      var meta = planMeta(p.name), pct = once ? Math.round((once - p.price)/once*100) : 0;
      var r = document.createElement('button'); r.type = 'button'; r.className = 'bb2-opt' + (p === def ? ' sel' : ''); r.setAttribute('role','radio'); r.setAttribute('aria-checked', p === def ? 'true' : 'false');
      r.setAttribute('data-mode','sub'); r.setAttribute('data-plan-id', p.id); r.setAttribute('data-plan-name', p.name);
      r.innerHTML = '<span class="radio"></span><span class="bb2-opt-main"><b>' + freqLabel(p.name) + (meta.tag ? ' <span class="pill">' + meta.tag + '</span>' : '') + '</b><span class="bb2-opt-sub">' + meta.sub + ' · swap, skip or cancel anytime</span></span><span class="bb2-opt-price"><b>' + money(p.price) + '</b>' + (pct > 0 ? '<s>' + money(once) + '</s> <span class="pill soft">Save ' + money(once - p.price) + '</span>' : '') + '</span>';
      opts.appendChild(r);
    });
    var o = document.createElement('button'); o.type = 'button'; o.className = 'bb2-opt once' + (list.length ? '' : ' sel'); o.setAttribute('role','radio'); o.setAttribute('aria-checked', list.length ? 'false' : 'true');
    o.setAttribute('data-mode','once');
    o.innerHTML = '<span class="radio"></span><span class="bb2-opt-main"><b>One-time box</b><span class="bb2-opt-sub">Full price · no subscription perks</span></span><span class="bb2-opt-price"><b>' + money(once) + '</b></span>';
    opts.appendChild(o);
    opts.querySelectorAll('.bb2-opt').forEach(function(r){
      r.addEventListener('click', function(){
        opts.querySelectorAll('.bb2-opt').forEach(function(x){ x.classList.remove('sel'); x.setAttribute('aria-checked','false'); });
        r.classList.add('sel'); r.setAttribute('aria-checked','true');
        mode = r.getAttribute('data-mode'); planId = mode === 'sub' ? parseInt(r.getAttribute('data-plan-id'),10) : null; planName = r.getAttribute('data-plan-name') || '';
        update();
      });
    });
    var sel = opts.querySelector('.bb2-opt.sel');
    mode = sel.getAttribute('data-mode'); planId = mode === 'sub' ? parseInt(sel.getAttribute('data-plan-id'),10) : null; planName = sel.getAttribute('data-plan-name') || '';
  }

  // ----- update everything -----
  function update(){
    var t = total(), tg = target(), left = Math.max(0, tg - t), full = t === tg;
    // progress
    countEl.textContent = t; targetEl.textContent = tg; leftEl.textContent = left;
    bar.style.width = Math.min(100, Math.round(t/tg*100)) + '%';
    prog.classList.toggle('full', full);
    hintEl.textContent = full ? '— your box is full 🎉' : ('— add ' + left + ' more');
    loaves.forEach(function(l){ l.classList.toggle('maxed', full); var p = l.querySelector('.bb2-plus'); if(p) p.disabled = full; var a = l.querySelector('.bb2-add'); if(a) a.disabled = full; });
    // add-on prices per mode
    addonEls.forEach(function(a){
      var now = planPrice(a), once = parseInt(a.getAttribute('data-once'),10)||0;
      var pe = a.querySelector('[data-addon-price]'), ce = a.querySelector('[data-addon-compare]'), le = a.querySelector('[data-addon-label]');
      if(pe) pe.textContent = money(now);
      if(ce){ ce.textContent = money(once); ce.hidden = !(mode === 'sub' && once > now); }
      if(le) le.textContent = mode === 'sub' ? 'subscriber price' : 'one-time price';
    });
    // summary
    sumSize.textContent = tg + ' loaves';
    sumLoaves.innerHTML = '';
    var any = false;
    loafCtl.forEach(function(c){ var n = c.ctl.get(); if(n){ any = true; var li = document.createElement('li'); li.innerHTML = '<span>' + n + '× ' + c.el.getAttribute('data-name') + '</span><span>included</span>'; sumLoaves.appendChild(li); } });
    if(!any){ sumLoaves.innerHTML = '<li class="empty">No loaves picked yet</li>'; }
    else if(left){ var li2 = document.createElement('li'); li2.className = 'empty'; li2.textContent = left + ' more to pick'; sumLoaves.appendChild(li2); }
    sumAddons.innerHTML = '';
    addonCtl.forEach(function(a){ var n = a.ctl.get(); if(n){ var li = document.createElement('li'); li.innerHTML = '<span>' + n + '× ' + a.el.getAttribute('data-name') + '</span><span>' + money(n * planPrice(a.el)) + '</span>'; sumAddons.appendChild(li); } });
    var ad = addonsTotal(), now = boxPrice() + ad.now, cmp = boxOnce() + ad.once;
    sumTotal.textContent = money(now);
    if(mode === 'sub' && cmp > now){ sumCompare.hidden = false; sumCompare.textContent = money(cmp); sumSave.hidden = false; sumSave.textContent = 'You save ' + money(cmp - now) + ' (' + Math.round((cmp-now)/cmp*100) + '%)'; }
    else { sumCompare.hidden = true; sumSave.hidden = true; }
    sumSched.textContent = mode === 'sub' ? ('Delivered ' + freqLabel(planName).toLowerCase() + ' · subscriber price') : 'One-time delivery';
    // CTA
    var label = full ? ('Add to cart — ' + money(now)) : ('Pick ' + left + ' more ' + (left === 1 ? 'loaf' : 'loaves'));
    cta.disabled = !full; cta.textContent = label;
    if(ctaM){ ctaM.disabled = !full; ctaM.textContent = full ? 'Add to cart' : 'Pick ' + left + ' more'; }
    if(mbCount) mbCount.textContent = t + ' / ' + tg;
    if(mbTotal) mbTotal.textContent = money(now);
    if(errEl){ errEl.hidden = true; }
  }

  // ----- wire cards -----
  loaves.forEach(function(el){
    var ctl = wireStepper(el, { canAdd: function(){ return total() < target(); }, onChange: update });
    if(ctl) loafCtl.push({el:el, ctl:ctl});
  });
  addonEls.forEach(function(el){
    var ctl = wireStepper(el, { max: 6, onChange: update });
    if(ctl) addonCtl.push({el:el, ctl:ctl});
  });

  // ----- size toggle -----
  function setSize(s, silent){
    sizes.forEach(function(x){ x.classList.remove('on'); x.setAttribute('aria-checked','false'); });
    s.classList.add('on'); s.setAttribute('aria-checked','true'); active = s;
    // if the current picks exceed the new target, trim from the last picked
    var over = total() - target();
    if(over > 0){ for(var i = loafCtl.length-1; i >= 0 && over > 0; i--){ var n = loafCtl[i].ctl.get(); var cut = Math.min(n, over); loafCtl[i].ctl.set(n - cut); over -= cut; } }
    renderOpts(); update();
    if(!silent){ var st = document.getElementById('step-loaves'); if(st && window.innerWidth < 900){ st.scrollIntoView({behavior:'smooth', block:'start'}); } }
  }
  sizes.forEach(function(s){ s.addEventListener('click', function(){ setSize(s); }); });
  // default: 6 unless ?size=8
  var want = (/[?&]size=8/.test(window.location.search)) ? '8' : '6';
  var def = sizes.filter(function(s){ return s.getAttribute('data-size') === want; })[0] || sizes[0];
  if(def) setSize(def, true);

  // ----- add to cart -----
  function submit(){
    if(cta.disabled) return;
    var props = { '_box_size': String(target()) };
    var names = [];
    loafCtl.forEach(function(c){ var n = c.ctl.get(); if(n){ props[c.el.getAttribute('data-name')] = String(n); names.push(n + '× ' + c.el.getAttribute('data-name')); } });
    props['Loaves'] = names.join(', ');
    var box = { id: parseInt(active.getAttribute('data-variant'),10), quantity: 1, properties: props };
    if(mode === 'sub' && planId) box.selling_plan = planId;
    var items = [box];
    addonCtl.forEach(function(a){ var n = a.ctl.get(); var vid = parseInt(a.el.getAttribute('data-variant'),10); if(n && vid){ var it = { id: vid, quantity: n }; if(mode === 'sub'){ var ap = planFor(a.el); if(ap) it.selling_plan = ap.id; } items.push(it); } });
    if(!box.id){ if(errEl){ errEl.hidden = false; errEl.textContent = 'This box isn\'t available yet — please try again shortly.'; } return; }
    var old = cta.textContent; cta.disabled = true; cta.textContent = 'Adding…'; if(ctaM){ ctaM.disabled = true; ctaM.textContent = 'Adding…'; }
    if(window.fbq){ try{ fbq('track','AddToCart',{content_name:'Build a Box '+target(), value:(boxPrice()+addonsTotal().now)/100, currency:'USD'}); }catch(e){} }
    addToCart(items, cartUrl, function(err){
      cta.disabled = false; cta.textContent = old; if(ctaM){ ctaM.disabled = false; ctaM.textContent = 'Add to cart'; }
      if(errEl){ errEl.hidden = false; errEl.textContent = (err && err.message) || 'Add to cart failed.'; }
    });
  }
  cta.addEventListener('click', submit);
  if(ctaM) ctaM.addEventListener('click', function(){ if(ctaM.disabled){ var st = document.getElementById('step-loaves'); if(st) st.scrollIntoView({behavior:'smooth'}); return; } submit(); });
})();

// ---------- PRODUCT PAGE: plan selector + qty + add to cart ----------
(function(){
  var root = document.getElementById('pdpBuy'); if(!root) return;
  var money = moneyFactory(root.getAttribute('data-money-format'));
  var cartUrl = root.getAttribute('data-cart-url') || '/cart';
  var variant = parseInt(root.getAttribute('data-variant'),10);
  var once = parseInt(root.getAttribute('data-once'),10) || 0;
  var plans = parseJSON(root.getAttribute('data-plans') || '[]', []).slice().sort(function(a,b){ return weeksOf(a.name) - weeksOf(b.name); });
  var optsEl = document.getElementById('pdpOpts'), cta = document.getElementById('pdpCta'), errEl = document.getElementById('pdpErr');
  var hdrPrice = document.getElementById('hdrPrice'), hdrWas = document.getElementById('hdrWas'), hdrSave = document.getElementById('hdrSave');
  var qtyCard = document.getElementById('pdpQty');
  var mode = 'sub', planId = null, price = once;
  var qty = qtyCard ? wireStepper(qtyCard, { min: 1, max: 10 }) : null;
  if(qty) qty.set(1);

  function render(){
    optsEl.innerHTML = '';
    var def = null; plans.forEach(function(p){ if(!def && /4\s*week/i.test(p.name)) def = p; }); if(!def && plans.length) def = plans[0];
    plans.forEach(function(p){
      var meta = planMeta(p.name), pct = once ? Math.round((once - p.price)/once*100) : 0;
      var r = document.createElement('button'); r.type = 'button'; r.className = 'bb2-opt' + (p === def ? ' sel' : '');
      r.setAttribute('data-mode','sub'); r.setAttribute('data-plan-id', p.id); r.setAttribute('data-price', p.price);
      r.innerHTML = '<span class="radio"></span><span class="bb2-opt-main"><b>' + freqLabel(p.name) + (meta.tag ? ' <span class="pill">' + meta.tag + '</span>' : '') + '</b><span class="bb2-opt-sub">Subscribe &amp; save · swap, skip or cancel anytime</span></span><span class="bb2-opt-price"><b>' + money(p.price) + '</b>' + (pct > 0 ? '<s>' + money(once) + '</s> <span class="pill soft">Save ' + money(once - p.price) + '</span>' : '') + '</span>';
      optsEl.appendChild(r);
    });
    var o = document.createElement('button'); o.type = 'button'; o.className = 'bb2-opt once' + (plans.length ? '' : ' sel');
    o.setAttribute('data-mode','once'); o.setAttribute('data-price', once);
    o.innerHTML = '<span class="radio"></span><span class="bb2-opt-main"><b>One-time purchase</b><span class="bb2-opt-sub">Full price · no subscription perks</span></span><span class="bb2-opt-price"><b>' + money(once) + '</b></span>';
    optsEl.appendChild(o);
    optsEl.querySelectorAll('.bb2-opt').forEach(function(r){ r.addEventListener('click', function(){
      optsEl.querySelectorAll('.bb2-opt').forEach(function(x){ x.classList.remove('sel'); }); r.classList.add('sel');
      mode = r.getAttribute('data-mode'); planId = mode === 'sub' ? parseInt(r.getAttribute('data-plan-id'),10) : null; price = parseInt(r.getAttribute('data-price'),10) || once; update();
    }); });
    var sel = optsEl.querySelector('.bb2-opt.sel'); mode = sel.getAttribute('data-mode'); planId = mode === 'sub' ? parseInt(sel.getAttribute('data-plan-id'),10) : null; price = parseInt(sel.getAttribute('data-price'),10) || once;
  }
  function update(){
    var n = qty ? qty.get() : 1, tot = price * n, cmp = once * n;
    if(hdrPrice) hdrPrice.textContent = money(price);
    if(hdrWas){ hdrWas.style.display = (mode === 'sub' && once > price) ? '' : 'none'; hdrWas.textContent = money(once); }
    if(hdrSave){ hdrSave.style.display = (mode === 'sub' && once > price) ? '' : 'none'; hdrSave.textContent = 'Save ' + money(once - price); }
    cta.textContent = (mode === 'sub' ? 'Subscribe — ' : 'Add to cart — ') + money(tot);
  }
  if(qtyCard){ qtyCard.querySelectorAll('button').forEach(function(b){ b.addEventListener('click', function(){ setTimeout(update, 0); }); }); }
  cta.addEventListener('click', function(){
    if(!variant){ return; }
    var it = { id: variant, quantity: qty ? qty.get() : 1 }; if(mode === 'sub' && planId) it.selling_plan = planId;
    var old = cta.textContent; cta.disabled = true; cta.textContent = 'Adding…';
    if(window.fbq){ try{ fbq('track','AddToCart',{value: (price*(qty?qty.get():1))/100, currency:'USD'}); }catch(e){} }
    addToCart([it], cartUrl, function(err){ cta.disabled = false; cta.textContent = old; if(errEl){ errEl.hidden = false; errEl.textContent = (err && err.message) || 'Add to cart failed.'; } });
  });
  render(); update();
})();

});
